import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import {
  createWarehouse,
  getBrandWarehouseById,
  putWarehouse,
} from "../../../services/warehouse/Warehouse";
import {
  addBrandLocality,
  updateBrandLocality,
} from "../../../services/Locality/Locality";
import AdminMenu from "../../AdminMenu";

const LocalityCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  let orderEditModel = brandProfileData.orderEditModel;

  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [input, setInput] = useState({
    landmark: "",
    pin: "",
    city: "",
    state: "",
    locality: "",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    setInput((prevState) => ({
      ...prevState,
      landmark: item?.landmark || "",
      pin: item?.pin || "",
      city: item?.city || "",
      state: item?.state || "",
      locality: item?.locality || "",
      latitude: item?.latitude?.toString() || "",
      longitude: item?.longitude?.toString() || "",
    }));
  }, [item]);

  const [localityError, setLocalityError] = useState("");
  const [latitudeError, setLatitudeError] = useState("");
  const [longitudeError, setLongitudeError] = useState("");
  const [stateError, setStateError] = useState("");
  const [pincodeError, setPincodeError] = useState("");

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemPress = () => {
    setSelectedItem((prevSelectedItem) => !prevSelectedItem);
  };

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setLocalityError("");
    setLatitudeError("");
    setLongitudeError("");
    setStateError("");
    setPincodeError("");

    let isValid = true;
    if (!input.locality) {
      setLocalityError("Locality is Required");
      isValid = false;
    }
    if (!input.locality) {
      setLongitudeError("Longitude is Required");
      isValid = false;
    }
    if (!input.locality) {
      setLatitudeError("Latitude is Required");
      isValid = false;
    }

    if (!input.state) {
      setStateError("State Name is Required");
      isValid = false;
    }

    if (!input.pin) {
      setPincodeError("Pin Code is Required");
      isValid = false;
    }

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...input,
          brandId: brandId,
        };

        const UpdateData = {
          ...input,
          brandId: brandId,
          id: item?.id,
        };

        // Call the service function for creating pickup request

        if (!isUpdating) {
          addBrandLocality(data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/LocalityView");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updateBrandLocality(UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/LocalityView");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/LocalityView")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Locality {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="locality"
              value={input.locality}
              onChange={(e) => {
                setInput({
                  ...input,
                  locality: e.target.value,
                });
                setLocalityError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {localityError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {localityError}
              </p>
            )}

            <label
              htmlFor="locality"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Locality <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="city"
              value={input.city}
              onChange={(e) => {
                setInput({
                  ...input,
                  city: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label htmlFor="city" className="text-lg" style={{ color: "blue" }}>
              City 
            </label>
          </FloatLabel>
        </div>
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="state"
              value={input.state}
              onChange={(e) => {
                setInput({
                  ...input,
                  state: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={10}
            />
            {stateError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {stateError}
              </p>
            )}

            <label
              htmlFor="state"
              className="text-lg"
              style={{ color: "blue" }}
            >
              State <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      {/* address */}

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="landmark"
              value={input.landmark}
              onChange={(e) => {
                setInput({
                  ...input,
                  landmark: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            <label
              htmlFor="landmark"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Landmark
            </label>
          </FloatLabel>
        </div>
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="pin"
              value={input.pin}
              onChange={(e) =>
              {
                const value = e.target.value
                if (/^\d*$/.test(value)) {
                setInput({
                  ...input,
                  pin: value,
                })
                }}
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
             {pincodeError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {pincodeError}
              </p>
            )}

            <label htmlFor="pin" className="text-lg" style={{ color: "blue" }}>
              Pin Code <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="Latilatitudetude"
              value={input.latitude}
              onChange={(e) => {
                setInput({
                  ...input,
                  latitude: e.target.value,
                });
                setLatitudeError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            {latitudeError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {latitudeError}
              </p>
            )}
            <label
              htmlFor="latitude"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Latitude <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="longitude"
              value={input.longitude}
              onChange={(e) => {
                setInput({
                  ...input,
                  longitude: e.target.value,
                });
                setLongitudeError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {longitudeError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {longitudeError}
              </p>
            )}

            <label
              htmlFor="longitude"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Longitude <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default LocalityCreate;
